import { createRouter as createTanstackRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

import { DefaultErrorComponent } from "@bidbattles/bloks/components/errors";
import { PageLoader } from "@bidbattles/bloks/components/ui/loading";
import { MutationCache, QueryClient } from "@tanstack/react-query";

import { config as fontAwesomeConfig } from "@fortawesome/fontawesome-svg-core";
import { configureBloks } from "./lib/bloks";
configureBloks();
fontAwesomeConfig.autoAddCss = false;

// Create a new router instance
export const getRouter = () => {
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				staleTime: 15 * 1000,
			},
		},
		mutationCache: new MutationCache({
			onSuccess: (_data, _variables, _context, mutation) => {
				queryClient.invalidateQueries({
					queryKey: mutation.options.mutationKey,
				});
			},
		}),
	});

	const router = createTanstackRouter({
		routeTree,
		context: {
			queryClient,
		},
		scrollRestoration: true,
		defaultPreloadStaleTime: 0,
		defaultPendingComponent: PageLoader,
		defaultErrorComponent: DefaultErrorComponent,
	});
	setupRouterSsrQueryIntegration({ router, queryClient });

	return router;
};
export type BBRouter = ReturnType<typeof getRouter>;

// Register the router instance for type safety
declare module "@tanstack/react-router" {
	interface Register {
		router: BBRouter;
	}
}
